<div class="c-widget__table">
  <div class="c-widget__header">
    <div class="c-widget__content-left">
      <div class="c-widget__title" i18n="@@common.questions">Questions</div>
      <button p500-ui-button-icon size="small" color="primary" type="button" (click)="getData()">
        <p500-ui-icon name="controls-refresh"></p500-ui-icon>
      </button>
    </div>
  </div>
  <!-- table -->
  <div class="c-widget__body">
    <table *ngIf="!isLoading; else loadingTmpl">
      <thead>
        <th i18n="@@common.question">Question</th>
        <th i18n="@@common.answer">Answer</th>
      </thead>
      <tbody>
        <ng-container *ngIf="answers.length; then dataTmpl; else emptyTmpl"></ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #loadingTmpl>
  <div class="c-widget">
    <div class="c-widget__body">
      <p500-ui-cube-preloader></p500-ui-cube-preloader>
    </div>
  </div>
</ng-template>

<ng-template #dataTmpl>
  <tr *ngFor="let item of answers">
    <td>
      <gtd-ui-field-default-string-whitespace-or-empty [data]="item.questionText"> </gtd-ui-field-default-string-whitespace-or-empty>
    </td>
    <td>
      <ng-container *ngIf="item.shortAnsw">
        <gtd-ui-field-default-string-whitespace-or-empty [data]="item.shortAnsw"> </gtd-ui-field-default-string-whitespace-or-empty>
      </ng-container>
      <ng-container *ngIf="!item.shortAnsw">
        <p500-ui-many-items [data]="item.answer" title="Answers" [tmpl]="tmpl" [previewTmpl]="previewTmpl"> </p500-ui-many-items>
        <ng-template let-data="data" #previewTmpl>
          <gtd-ui-field-default-string-whitespace-or-empty [data]="data"> </gtd-ui-field-default-string-whitespace-or-empty>
        </ng-template>
        <ng-template let-data="data" #tmpl>
          <span class="fs-12 fw-bold">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data"> </gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </ng-template>
      </ng-container>
    </td>
  </tr>
</ng-template>

<ng-template #emptyTmpl>
  <tr>
    <td colspan="100%">
      <gtd-empty [icon]="'box'" [noBorder]="true" i18n-desc="@@common.data_wasnt_found" desc="Data wasn't found."> </gtd-empty>
    </td>
  </tr>
</ng-template>
